/* Small shared pieces for the Benefits Wallet. */

export const fmt = (n) => (n == null || n === "" ? "—" : Number(n).toLocaleString());

export const StatusBadge = ({ it }) => {
  const st = it.effective_status || "active";
  const d = it.days_to_expiry;
  if (st === "active" && d != null && d >= 0 && d <= 60) {
    return (
      <span className="inline-flex items-center gap-1 text-[11px] font-700 px-1.5 py-0.5 rounded bg-amber-100 text-amber-800" data-testid={`wallet-status-${it.id}`}>
        <span className="w-1.5 h-1.5 rounded-full bg-amber-500" /> {d === 0 ? "Expires today" : `Expires in ${d}d`}
      </span>
    );
  }
  const map = {
    active: ["bg-emerald-50 text-emerald-700", "bg-emerald-500", "Active"],
    used: ["bg-zinc-100 text-zinc-600", "bg-zinc-400", "Used"],
    expired: ["bg-rose-100 text-rose-700", "bg-rose-500", "Expired"],
    archived: ["bg-zinc-100 text-zinc-500", "bg-zinc-300", "Archived"],
  };
  const [cls, dot, label] = map[st] || map.active;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] font-700 px-1.5 py-0.5 rounded ${cls}`} data-testid={`wallet-status-${it.id}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} /> {label}
      {st === "active" && d != null && d > 60 ? ` · ${d}d left` : ""}
    </span>
  );
};

const inputCls = "w-full border border-zinc-300 px-3 py-2 text-sm outline-none focus:ring-2 focus:ring-primary bg-white";

export function FieldInput({ f, value, onChange }) {
  const v = value ?? "";
  const set = (x) => onChange(f.k, x);
  if (f.t === "select") {
    return (
      <label className={`text-xs text-muted-foreground ${f.full ? "sm:col-span-2" : ""}`}>{f.l}
        <select value={v} onChange={(e) => set(e.target.value)} data-testid={`wallet-field-${f.k}`} className={`${inputCls} mt-1`}>
          {f.opts.map(([val, lab]) => <option key={val} value={val}>{lab}</option>)}
        </select>
      </label>
    );
  }
  if (f.t === "yesno") {
    return (
      <label className="text-xs text-muted-foreground">{f.l}
        <select value={v} onChange={(e) => set(e.target.value)} data-testid={`wallet-field-${f.k}`} className={`${inputCls} mt-1`}>
          <option value="">—</option><option value="yes">Yes</option><option value="no">No</option>
        </select>
      </label>
    );
  }
  if (f.t === "textarea" || f.t === "list") {
    const val = f.t === "list" && Array.isArray(v) ? v.join("\n") : v;
    return (
      <label className={`text-xs text-muted-foreground ${f.full ? "sm:col-span-2" : ""}`}>{f.l}
        <textarea value={val} rows={2} placeholder={f.ph} data-testid={`wallet-field-${f.k}`}
          onChange={(e) => set(f.t === "list" ? e.target.value.split("\n") : e.target.value)} className={`${inputCls} mt-1`} />
      </label>
    );
  }
  return (
    <label className={`text-xs text-muted-foreground ${f.full ? "sm:col-span-2" : ""}`}>{f.l}
      <input type={f.t === "date" ? "date" : f.t === "number" ? "number" : "text"} value={v}
        placeholder={f.ph} data-testid={`wallet-field-${f.k}`}
        onChange={(e) => set(e.target.value)} className={`${inputCls} mt-1`} />
    </label>
  );
}
